/** @format */

import React, { FC, useEffect, useState, createContext } from 'react'
import { Route, useHistory, useLocation } from 'react-router-dom'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'

interface IRouterContext {
  region?: string
}
export const RouterContext = createContext<IRouterContext>({})
const CustomRoute: FC<any> = props => {
  const { pathname } = useLocation()
  const history = useHistory()
  const productMenu = useGlobalData('productMenu')
  const [contextState, setContextState] = useState<IRouterContext>({})
  const gloabalRegionList = useGlobalData('monitorRegionList') as RegionStateType['list']

  useEffect(() => {
    const split = pathname.split('/')
    let windowRegion = null
    if (pathname.includes('/monitor/list/') && split?.length === 4) {
      const productName = split[3]
      const findType = productMenu.find(({ link }) => link.split('/')[3] === productName)
      if (findType && gloabalRegionList?.length) {
        const storageRegion = localStorage.getItem('systemId')
        const regionData = gloabalRegionList?.map(item => {
          return {
            regionCode: item.regionKey,
            ...item
          }
        })
        windowRegion = window['__ksStorage__'].initRegion(regionData, storageRegion)
        window['__ksStorage__'].on('region', data => {
          if (data !== storageRegion) {
            localStorage.setItem('systemId', data)
          }
          setContextState({
            region: data
          })
        })
      }
    } else if (pathname.includes('/monitor/list') && split?.length === 3) {
      history.push('/monitor/generalview/home')
    }
    return () => {
      windowRegion?.remove && windowRegion?.remove()
    }
  }, [pathname, gloabalRegionList])

  return (
    <RouterContext.Provider value={contextState}>
      <Route {...props}></Route>
    </RouterContext.Provider>
  )
}

export default CustomRoute
